export const Theme = {
    colors : {
        primary: 'rgb(69, 80, 94)',
        secondary: '#8C9CAD', 
        tertiary: 'rgb(46, 55, 66)',
        quaternary: '#008B57',
        quinary:  'rgba(0, 171, 99, 1)',
        white: '#FFFFFF',
        gray: '#D7E0EB'
    },
    fonts: {
        fontStyle1: 'Roboto, sans-serif',
        fontStyle2: 'CircularStd, sans-serif',
    }
}